import React from 'react';
import './styling.css';

function TextComponent({ question }) {
  return <div className="shared-padding text-component">{question.Text}</div>;
}
export default TextComponent;
